import React, { FC } from 'react';
import CustomExternalAnchor from '../../../customExternalAnchor';
import RoutableSitecoreLink from '../../../routableSitecoreLink';
import { TLinkChildrenAndIcon } from '../../types/cta.types';
import ArrowRight from './arrowRight';

const LinkChildrenAndIcon: FC<TLinkChildrenAndIcon> = (props) => {
  const { isEditing, onClick, field, ctaClassName, children, hasArrowRight, type, target } = props;
  if (isEditing) {
    return (
      <span className={ctaClassName}>
        <CustomExternalAnchor field={field} onClick={onClick} />
        {children}
        {hasArrowRight && <ArrowRight type={type} />}
      </span>
    );
  } else if (children) {
    return (
      <RoutableSitecoreLink field={field} className={ctaClassName} onClick={onClick}>
        {children}
        {hasArrowRight && <ArrowRight type={type} />}
      </RoutableSitecoreLink>
    );
  } else if (hasArrowRight) {
    return (
      <RoutableSitecoreLink field={field} target={target} className={ctaClassName} onClick={onClick}>
        {field.value.text || field.value.href}
        {<ArrowRight type={type} />}
      </RoutableSitecoreLink>
    );
  }
  return null;
};

export default LinkChildrenAndIcon;
